import React, { useCallback, useEffect, useRef } from 'react';
import { useGoogleLoginRenderButton } from 'Hooks/Auth';
import { GoogleSignUpData } from 'Interfaces/Auth';
import { OnSubmitReturnType } from 'Interfaces/FinalForm';
import { jwtDecode } from 'jwt-decode';

interface GoogleLoginFormProps {
  onSubmit: (values: GoogleSignUpData) => OnSubmitReturnType;
  width: number;
  text?: 'signin_with' | 'signup_with' | 'continue_with' | 'signin';
}

const GoogleLoginForm = ({ onSubmit, width, text }: GoogleLoginFormProps) => {
  const buttonRef = useRef<HTMLDivElement>(null);

  const handleSuccess = useCallback(
    response => {
      const parseToken: any = jwtDecode(response.credential);
      onSubmit({
        email: parseToken.email,
        id_token: response.credential,
        name: parseToken.name,
      });
    },
    [onSubmit],
  );

  const renderButton = useGoogleLoginRenderButton({ onSubmit: handleSuccess });

  useEffect(() => {
    renderButton(buttonRef.current, {
      type: 'standard',
      theme: 'outline',
      size: 'large',
      shape: 'pill',
      text,
      width,
    });
  }, [renderButton, text, width]);

  return <div ref={buttonRef} />;
};

export default GoogleLoginForm;
